import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { NumericTextFieldValidator } from '../../../validations/numeric-text-field-validator'
import { LengthTextFieldValidator } from '../../../validations/length-text-field-validator'
import { Address, blankAddress } from '../../../common/models/address'
import { FieldValidator } from '../../../validations/field-validator'
import { NotPoBoxAddressTextFieldValidator } from '../../../validations/not-po-box-address-text-field-validator'
import { Validatable } from '../../../validations/validatable'
import { FormValidationService } from '../../../validations/form-validation-service'
// import { State } from '../../../common/models/state'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { StateGateway } from '../../gateways/state-gateway'

@Component({
    selector: 'AddressGroup',
    templateUrl: 'address-group.component.html'
})

export class AddressGroupComponent extends Validatable<Address> implements OnInit {
    @Input() disabled = false
    @Input() states: State[]
    @Input() allowPOBoxes = true
    @Input()
    set address(value: Address) {
        if (value) {
            this._address = value
        } else {
            this._address = blankAddress()
        }
    }
    get address(): Address {
        return this._address
    }

    @Output() onValueChange: EventEmitter<Address> = new EventEmitter<Address>()

    _address: Address = blankAddress()

    notBlankValidator = new NotBlankGenericFieldValidator()
    numericValidator = new NumericTextFieldValidator()
    zipCodeValidator = new LengthTextFieldValidator(5)
    zip4CodeValidator = new LengthTextFieldValidator(4)
    line1Validators: FieldValidator<string>[] = []
    line2Validators: FieldValidator<string>[] = []

    constructor(formValidationService: FormValidationService,
        private _stateGateway: StateGateway) {
        super(formValidationService)
        this._stateGateway.getAllStates().subscribe(
            (states: State[]) => {
                this.states = states
                this.states.unshift({ value: 0, text: '-- Choose One --', })
            } 
        )
    }

    ngOnInit(): void {
        this.line1Validators.push(this.notBlankValidator)
        if (!this.allowPOBoxes) {
            this.line1Validators.push(new NotPoBoxAddressTextFieldValidator())
            this.line2Validators.push(new NotPoBoxAddressTextFieldValidator())
        }
    }

    updateAddress(fieldName: string, fieldValue: string | State) {
        this.validate()
        if (fieldName === 'state.code') {
            let state: any = this.address['state']
            state.code = fieldValue
            this.address['state'] = state
        } else {
            this.address[fieldName] = fieldValue
        }
        this.onValueChange.emit(this.address)
    }

    onBlur() {
        this.validate()
    }

    getValue(): Address {
        return this.address
    }

    getLabel(): string {
        return ''
    }
}
